import { IconCircleCheck } from "@tabler/icons-react";
import styles from "../subscriptionPayment.module.css";
import moment from "moment";
import { fmtCurrency } from "../../../../utils/functions";

export default function CurrentPlanCard({ plan }) {
  const entitlements = plan?.entitlements;
  const rematchGuarantees = plan?.rematchGuarantees || [];

  return (
    <div className={styles.currentPlanCard}>
      <div className={styles.currentPlanTop}>
        <div className={styles.currentPlanBadge}>Current Plan</div>
        <div className={styles.currentPlanName}>{plan?.planName}</div>
        <div className={styles.currentPlanPrice}>
          {fmtCurrency(plan?.price, plan?.currency)}
        </div>
      </div>
      <div className={styles.currentPlanBody}>
        <div className={styles.planDetailRow}>
          <span className={styles.planDetailLabel}>Purchased</span>
          <span className={styles.planDetailValue}>
            {moment(plan?.validityPeriod)
              .subtract(1, "year")
              .format("MMM DD, YYYY")}{" "}
          </span>
        </div>
        <div className={styles.planDetailRow}>
          <span className={styles.planDetailLabel}>Valid until</span>
          <span
            className={`${styles.planDetailValue} ${styles.planDetailValueGreen}`}
          >
            {moment(plan?.validityPeriod).format("MMM DD, YYYY")}
          </span>
        </div>
        <div className={styles.planDetailRow}>
          <span className={styles.planDetailLabel}>Credits left</span>
          <span className={styles.planDetailValue}>
            {plan?.totalCredits} of {plan?.totalCreditsGranted}
          </span>
        </div>
        <div className={styles.planDetailRow}>
          <span className={styles.planDetailLabel}>Top-up rate</span>
          <span className={styles.planDetailValue}>{plan?.topUpRate}</span>
        </div>
        <div className={styles.planDetailRow}>
          <span className={styles.planDetailLabel}>Status</span>
          <span
            className={`${styles.planDetailValue} ${styles.planDetailValueGreen} flex items-center`}
          >
            <IconCircleCheck
              size={13}
              style={{ verticalAlign: "middle", marginRight: 2 }}
            />{" "}
            Active
          </span>
        </div>
        <div className={styles.planDetailRow}>
          <span className={styles.planDetailLabel}>Payment</span>
          <span
            className={`${styles.planDetailValue} ${styles.planDetailValueGreen}`}
          >
            Paid in full
          </span>
        </div>
        {entitlements && (
          <>
            <div className={styles.planDetailRow}>
              <span className={styles.planDetailLabel}>Shortlisted candidates</span>
              <span className={styles.planDetailValue}>
                {formatLimit(entitlements.candidateShortlistLimit)}
              </span>
            </div>
            <div className={styles.planDetailRow}>
              <span className={styles.planDetailLabel}>Active job posts</span>
              <span className={styles.planDetailValue}>
                {formatLimit(entitlements.activeJobPostsLimit)}
              </span>
            </div>
            <div className={styles.planDetailRow}>
              <span className={styles.planDetailLabel}>Analytics dashboard</span>
              <span className={styles.planDetailValue}>
                {entitlements.advancedAnalytics ? "Included" : "Not included"}
              </span>
            </div>
            <div className={styles.planDetailRow}>
              <span className={styles.planDetailLabel}>Success manager</span>
              <span className={styles.planDetailValue}>
                {entitlements.dedicatedSuccessManager ? "Dedicated" : "Not included"}
              </span>
            </div>
          </>
        )}
        {rematchGuarantees.length > 0 && (
          <div className={styles.planDetailRow}>
            <span className={styles.planDetailLabel}>Rematch guarantee</span>
            <span
              className={`${styles.planDetailValue} ${styles.planDetailValueGreen}`}
            >
              {rematchGuarantees.length} job
              {rematchGuarantees.length === 1 ? "" : "s"} to rematch at half cost
            </span>
          </div>
        )}
      </div>
    </div>
  );
}

const formatLimit = (limit) => (limit == null ? "Unlimited" : `Up to ${limit}`);
